import * as YinzCam__Stats__Standings from "./Standings/StandingsAtom.svelte";
import * as YinzCam__Stats__LeagueTableAtom from './LeagueTableTwo/LeagueTableTwoAtom.svelte';
import * as YinzCam__Stats__LeagueTableTwoAtom from './LeagueTableTwo/LeagueTableTwoAtom.svelte';
import * as YinzCam__Stats__FixturesStackedAtom from './FixturesCardStacked/FixturesStackedAtom.svelte';
import * as YinzCam__Stats__MCHeaderB from './MCHeaderB/MCHeaderBAtom.svelte';
import * as YinzCam__Stats__FixturesCardBAtom from './FixturesCardB/FixturesCardBAtom.svelte';
import * as YinzCam__Stats__FixturesCardCAtom from './FixturesCardC/FixturesCardCAtom.svelte';
import * as YinzCam__Stats__ManhattanChartAtom from './Manhattan/ManhattanChartAtom.svelte';
import * as YinzCam__Stats__WagonWheelCard from './WagonWheelCard/WagonWheelCardAtom.svelte';
import * as YinzCam__Stats__SwiperFixturesCardCAtom from './SwiperFixturesCardC/SwiperFixturesCardCAtom.svelte';
import * as YinzCam__Stats__BallByBallCard from './BallByBallCard/BallByBallCardAtom.svelte';
import * as YinzCam__Stats__CricketScorecardCard from './CricketScorecardCard/CricketScorecardCardAtom.svelte';
import * as YinzCam__Stats__WormChartCard from './WormChartCard/WormChartCardAtom.svelte';
import * as YinzCam__Stats__NVPlayMatchCentre from './NVPlayMatchCentre/NVPlayMatchCentreAtom.svelte';
import * as YinzCam__Stats__NVPlayScorecard from './NVPlayScorecard/NVPlayScorecardAtom.svelte';
import * as YinzCam__Stats__NVPlayMatchList from './NVPlayMatchList/NVPlayMatchListAtom.svelte';
import * as YinzCam__Stats__NVPlayVideoHighlights from './NVPlayVideoHighlights/NVPlayVideoHighlightsAtom.svelte';
import * as YinzCam__Stats__NVPlayVideoPlayer from './NVPlayVideoPlayer/NVPlayVideoPlayerAtom.svelte';

export const library = {
  YinzCam__Stats__Standings,
  YinzCam__Stats__LeagueTableAtom,
  YinzCam__Stats__LeagueTableTwoAtom,
  YinzCam__Stats__FixturesStackedAtom,
  YinzCam__Stats__MCHeaderB,
  YinzCam__Stats__FixturesCardBAtom,
  YinzCam__Stats__FixturesCardCAtom,
  YinzCam__Stats__SwiperFixturesCardCAtom,
  YinzCam__Stats__BallByBallCard,
  YinzCam__Stats__CricketScorecardCard,
  YinzCam__Stats__ManhattanChartAtom,
  YinzCam__Stats__WagonWheelCard,
  YinzCam__Stats__WormChartCard,
  YinzCam__Stats__NVPlayMatchCentre,
  YinzCam__Stats__NVPlayScorecard,
  YinzCam__Stats__NVPlayMatchList,
  YinzCam__Stats__NVPlayVideoHighlights,
  YinzCam__Stats__NVPlayVideoPlayer,
};
